import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Container, InputGroup, Form, Button } from 'react-bootstrap'
import { applyPromoOnTicket, promocodePost } from '../../redux/actions/promoCodeAction'
import { errorMessage } from '../../constants/errorMessage'
import qrcode from '../../assets/img/qr-code.png'
import ScanQr from './ScanQr'
import { Circles } from 'react-loader-spinner'
import { getTicketDetails } from '../../redux/actions/ReceiptsAction'
// import { getConfigDetails } from '../../services/config'
import {
    loggedInUserData
} from '../../utils/helper'
import { getConfigDetails } from '../../../../services/config'

function PromoCode(props) {
    const { facility, dispatch, setStateList, setFaciltyData, setValue, setErrorMessageLocal, length, isTicketApply, notify, setPaymentData, screen, ticketDetails, getValues } = props
    const [promoCode, setPromoCode] = useState('')
    const [isPromoCodeAppiled, setIsPromoCodeApplied] = useState(false)
    const [scanResult, setScanResult] = useState(null)
    const [isScanDisplay, setIsScanDisplay] = useState(false)
    const [message, setMessage] = useState('')
    const [isError, setIsError] = useState(false)
    const [isApplyValidateCode, setIsApplyValidateCode] = useState(false)

    const facilityData = JSON.parse(localStorage.getItem('faclityData') ? localStorage.getItem('faclityData') : '{}')
    const rateData = JSON.parse(localStorage.getItem('seletedRateBand') ? localStorage.getItem('seletedRateBand') : '{}')

    const handlePromoCode = (e) => {
        e.preventDefault()
        const { value } = e.target
        setPromoCode(value?.toUpperCase())
        setIsError(false)
        setMessage('')
        if (value == '') {
            handleResetPromocode()
        }
    }

    useEffect(() => {
        if (scanResult) {
            setPromoCode(scanResult?.toUpperCase())
        }
    }, [scanResult])

    useEffect(() => {
        handleResetPromocode()
    }, [length])

    useEffect(() => {
        if (ticketDetails?.promocode && ticketDetails?.promocode != '') {
            setIsPromoCodeApplied(true)
            setPromoCode(ticketDetails?.promocode)
            setMessage(`${ticketDetails?.promocode} applied`)
        }

    }, [])

    const handleResetPromocode = () => {
        if (isPromoCodeAppiled) {
            setPromoCode('')
            if (isTicketApply) {
                const paymentDetails = JSON.parse(localStorage.getItem('paymentRecipt'))
                const finalPayload = {
                    ticket_id: paymentDetails?.ticket_number,
                    is_promocode_apply: '0',
                    promocode: promoCode
                }

                dispatch(applyPromoOnTicket(finalPayload)).then((res) => {
                    if (res?.data) {
                        // const listItem = [{ 'headerName': 'Parking Amount', 'val': `$${res?.data?.base_amount}` }, { 'headerName': 'Tax', 'val': `$${res?.data?.tax_fee}` }, { 'headerName': 'Processing Fee', 'val': `$${res?.data?.processing_fee}` }]
                        if (screen && screen == 'extend') {
                            localStorage.removeItem('ExtendData')
                            localStorage.setItem('ExtendData', JSON.stringify(res?.data))
                        } else {
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(res?.data))
                        }
                        localStorage.setItem('isCouponApplied', false)
                        setPaymentData(res?.data)
                        setIsPromoCodeApplied(false)
                        setIsError(false)
                        setMessage('Validation Code Removed')
                        //NEED TO UPDATE THE PAYMENT DATA
                        //get ticket details
                        const payloadTicket = {
                            'ticket': paymentDetails?.ticket_number,
                            'phone': '',
                            'cardLast4': '',
                            'cardExpiry': '',
                            'license_plate': '',
                            'partner_id': getConfigDetails()?.PARTNER_ID,
                        }
                        dispatch(getTicketDetails(payloadTicket)).then((res) => {
                            if (res?.status === 201 || res?.status === 200) {
                                if (res?.data && res?.data != null) {
                                    // notify('success', 'T successfully')
                                    setPaymentData(res?.data)
                                    localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))


                                    // setRemainingAmount(formatDecimal(Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)))
                                } else {
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                }
                            } else {
                                // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                        }).catch(() => {
                            notify('error', errorMessage?.somethingWentWrong)
                        })
                        //end
                    } else {
                        setIsPromoCodeApplied(true)
                        notify('error', errorMessage?.somethingWentWrong)
                        setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsError(true)
                        setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                }).catch((err) => {
                    setIsPromoCodeApplied(true)
                    notify('error', errorMessage?.somethingWentWrong)
                    setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            } else {
                const finalPayload = {
                    'encrypt': facility
                }
                if (facilityData?.facility?.is_price_band == 1 && rateData?.id) {
                    finalPayload.rate_band_id = rateData?.id
                    finalPayload.promocode = ''
                    finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                } else {
                    finalPayload.length = length
                }
                dispatch(promocodePost(finalPayload)).then((res) => {
                    if (res?.data) {
                        setIsPromoCodeApplied(false)


                        localStorage.setItem('faclityData', JSON.stringify(res?.data))

                        setStateList(res?.data?.states)
                        setFaciltyData(res?.data)
                        localStorage.setItem('isCouponApplied', false)
                        const geoState = res?.data?.facility?.geolocations?.state
                        const filteredState = res?.data?.states?.filter((item) => item?.state_code === geoState ? item : 0)
                        setValue('state', filteredState[0]?.id)
                        setIsError(false)
                        setMessage('Validation Code Removed')
                    } else {
                        setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsError(true)
                        setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                }).catch((err) => {
                    setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            }
        } else {
            setPromoCode('')
        }
    }

    const handleSubmitPromoCode = () => {
        setIsApplyValidateCode(true)
        if (promoCode !== '' && promoCode !== null) {
            if (isTicketApply) {

                const paymentDetails = JSON.parse(localStorage.getItem('paymentRecipt'))
                const finalPayload = {
                    ticket_id: paymentDetails?.ticket_number,
                    is_promocode_apply: '1',
                    promocode: promoCode,
                    'phone': paymentDetails?.user?.phone_number ? paymentDetails?.user?.phone_number : loggedInUserData()?.user?.phone ? loggedInUserData()?.user?.phone : '',
                    'license_plate': paymentDetails?.user?.license_plate ? paymentDetails?.user?.license_plate : '',
                    'email': loggedInUserData()?.user?.email
                }

                if (facilityData?.facility?.is_price_band == 1 && rateData?.id) {
                    finalPayload.rate_band_id = rateData?.id
                } else {
                    finalPayload.length = length
                }

                dispatch(applyPromoOnTicket(finalPayload)).then((res) => {
                    setIsPromoCodeApplied(true)
                    if (res?.data) {
                        setIsApplyValidateCode(false)
                        localStorage.setItem('isCouponApplied', true)
                        setPaymentData(res?.data)
                        setIsPromoCodeApplied(true)
                        setIsError(false)
                        // setMessage('Validation Code Applied Successfully')
                        setMessage(`${promoCode} applied`)
                        //get ticket details
                        const payloadTicket = {
                            'ticket': paymentDetails?.ticket_number,
                            'phone': '',
                            'cardLast4': '',
                            'cardExpiry': '',
                            'license_plate': '',
                            'partner_id': getConfigDetails()?.PARTNER_ID,
                        }
                        dispatch(getTicketDetails(payloadTicket)).then((res) => {
                            if (res?.status === 201 || res?.status === 200) {
                                if (res?.data && res?.data != null) {
                                    // notify('success', 'T successfully')
                                    setPaymentData(res?.data)
                                    localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))


                                    // setRemainingAmount(formatDecimal(Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)))
                                } else {
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                }
                            } else {
                                // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                        }).catch(() => {
                            notify('error', errorMessage?.somethingWentWrong)
                        })
                        //end
                    } else {
                        // notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsApplyValidateCode(false)
                        setIsPromoCodeApplied(false)
                        localStorage.setItem('isCouponApplied', false)
                        // setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsError(true)
                        setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                }).catch((err) => {
                    // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsApplyValidateCode(false)
                    setIsPromoCodeApplied(false)
                    localStorage.setItem('isCouponApplied', false)
                    // setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            } else {
                const formData = getValues()
                if (length > 0 || formData?.rate_band_id) {
                    const finalPayload = {
                        'encrypt': facility,
                        promocode: promoCode,
                        'is_guest': '1',
                        'phone': formData?.phone ? formData?.phone : loggedInUserData()?.user?.phone ? loggedInUserData()?.user?.phone : '',
                        'license_plate': formData?.license_plate ? formData?.license_plate : '',
                        'email': loggedInUserData()?.user?.email
                    }
                    if (facilityData?.facility?.is_price_band == 1 && rateData?.id) {
                        finalPayload.rate_band_id = rateData?.id
                    } else {
                        finalPayload.length = length
                    }
                    dispatch(promocodePost(finalPayload)).then((res) => {
                        if (res?.data) {
                            setIsApplyValidateCode(false)
                            setIsPromoCodeApplied(true)

                            localStorage.setItem('faclityData', JSON.stringify(res?.data))
                            setStateList(res?.data?.states)
                            setFaciltyData(res?.data)
                            localStorage.setItem('isCouponApplied', true)
                            const geoState = res?.data?.facility?.geolocations?.state
                            const filteredState = res?.data?.states?.filter((item) => item?.state_code === geoState ? item : 0)
                            setValue('state', filteredState[0]?.id)
                            setIsError(false)
                            // setMessage('Validation Code Applied Successfully')
                            setMessage(`${promoCode} applied`)

                        } else {
                            setIsApplyValidateCode(false)
                            setIsError(true)
                            localStorage.setItem('isCouponApplied', false)
                            setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                    }).catch((err) => {
                        setIsApplyValidateCode(false)
                        setIsError(true)
                        localStorage.setItem('isCouponApplied', false)
                        setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                } else {
                    setIsApplyValidateCode(false)
                    notify('error', 'Please select valid duration.')
                }
            }

        } else {
            setIsApplyValidateCode(false)
            setIsError(true)
            setMessage('Please enter a validation code')
        }

    }

    const handleQrScan = () => {
        setIsScanDisplay(true)
    }
    return (
        <div><Container className='mb-3 mt-3'>
            {/* <Form.Label className='text-info styleLables'>Promo Code</Form.Label> */}
            <InputGroup className=" myiconset border py-2 rounded d-flex justify-content-center align-items-center">
                <Form.Control className='border-0' placeholder="Validation Code" aria-label="PromoCode" aria-describedby="basic-addon2" value={promoCode} onChange={handlePromoCode} />
                {!isPromoCodeAppiled ?

                    <Button disabled={isApplyValidateCode} className='border-0' variant=" text-primary" type='button' id="button-addon2" onClick={handleSubmitPromoCode}>
                        <div className='d-flex'>
                            <span className='me-2'>Apply</span>
                            {isApplyValidateCode ?

                                <Circles
                                    height="20"
                                    width="20"
                                    style={{ display: 'inline-block' }}
                                    color="var(--bs-primary)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /> : ''}

                        </div>

                    </Button>


                    :
                    <Button variant=" text-danger" type='button' id="button-addon2" onClick={handleResetPromocode}><i className='fa-1x fa fa-times'> </i></Button>}
                <img src={qrcode} className='me-2 qr-img' alt="Scan QR for Code" onClick={() => handleQrScan()} />
            </InputGroup>
            <span className={isError ? 'text-danger small text-left mt-1' : 'text-success small text-left mt-1'}>{isPromoCodeAppiled ? <i className='me-1 fa fa-check-circle'></i> : ''}{message}</span>
        </Container>
            {isScanDisplay && <ScanQr setScanResult={setScanResult} scanResult={scanResult} setIsScanDisplay={setIsScanDisplay} />}
        </div>
    )
}

PromoCode.propTypes = {
    dispatch: PropTypes.func,
    facility: PropTypes.string,
    setStateList: PropTypes.func,
    setFaciltyData: PropTypes.func,
    setValue: PropTypes.func,
    setErrorMessageLocal: PropTypes.func,
    length: PropTypes.string,
    isTicketApply: PropTypes.bool,
    notify: PropTypes.func,
    setPaymentData: PropTypes.func,
    screen: PropTypes.string,
    resetPromocode: PropTypes.bool,
    ticketDetails: PropTypes.object,
    getValues: PropTypes.func,
}

PromoCode.defaulProps = {
    dispatch: noop,
    facility: '',
    setStateList: noop,
    setFaciltyData: noop,
    setValue: noop,
    setErrorMessageLocal: noop,
    length: '',
    isTicketApply: false,
    notify: noop,
    setPaymentData: noop,
    screen: '',
    resetPromocode: false,
    PropTypes: noop,
    getValues: noop,
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(PromoCode)